import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API from "../../API";
import InterestedProviders from "./InterestedProviders"

const InterestedProvidersContainer = ({ project_id, hiredProviderId }) => {
    const [interestedProviders, setInterestedProviders] = useState([]);
    const [interestedProvidersLoading, setInterestedProvidersLoading] = useState(false);
    const [hasLimit, setHasLimit] = useState(false);
    const [notYetApiHitted, setNotYetApiHitted] = useState(true);

    useEffect(() => {
        const fetchInterestedProviders = async () => {
            setInterestedProvidersLoading(true);
            try {
                const response = await axios.get(
                    API.baseURL + `/v2/customers/projects/${project_id}/details/providers`,
                    API.options
                );
                console.log(response.data,'response.data');
                setInterestedProviders(response.data?.data?.interested_providers);
                setHasLimit(response.data?.data?.has_limit);
                setNotYetApiHitted(false);
            } catch (error) {
                console.error('Error fetching interested providers:', error);
                if (error?.response?.status === 401) {
                    window.location.href = `/logout`;
                }
            } finally {
                setInterestedProvidersLoading(false);
            }
        };

        fetchInterestedProviders();
    }, [project_id]);

    const project_not_yet_hired = true;

    return (
        <InterestedProviders
            project_id={project_id}
            interestedProviders={interestedProviders??[]}
            has_limit={hasLimit}
            interestedProvidersLoading={interestedProvidersLoading}
            provider_hired_id={hiredProviderId}
            not_yet_api_hitted={notYetApiHitted}
        />
    );
}

export default InterestedProvidersContainer;